import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import { CircularProgress } from "@material-ui/core";
import {
  SET_TAG_FILES_STATUS,
  SET_TAG_FILES_SELECTION,
  SET_TAG_FILES_SELECT_MODE,
} from "../DataTagConstants";
import TagFilesDialog, { EMPTY_SELECTION } from "./TagFilesDialog";
import "./TagFilesDialog.scss";

// Sits at the right end of the tab row. Only NTFS data sources get it.
export default function TagFilesButton() {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  // picks live in redux so the All Files table can tick files into them
  const selected =
    useSelector((state) => state.dataTagReducer.tagFilesSelection) ||
    EMPTY_SELECTION;
  const selectMode = useSelector(
    (state) => !!state.dataTagReducer.tagFilesSelectMode,
  );
  const setSelected = (value) =>
    dispatch({ type: SET_TAG_FILES_SELECTION, payload: value });
  const setSelectMode = (value) =>
    dispatch({ type: SET_TAG_FILES_SELECT_MODE, payload: value });

  const dataSourceId = useSelector(
    (state) => state.dataTagReducer.selectedDataSource?.id,
  );

  const isNTFS = useSelector(
    (state) => state.dataTagReducer.selectedDataSource?.type === "NTFS",
  );
  const isDataBase = useSelector((state) => state.dataTagReducer.isDatabase);
  const loading = useSelector(
    (state) => !!state.dataTagReducer.tagFilesStatus?.loading,
  );

  // a different data source means different files, so start fresh
  const lastSourceId = useRef(dataSourceId);
  useEffect(() => {
    if (lastSourceId.current !== dataSourceId) {
      lastSourceId.current = dataSourceId;
      setSelected(EMPTY_SELECTION);
      setSelectMode(false);
    }
  }, [dataSourceId]);

  if (!isNTFS || isDataBase) return null;

  const handleOpen = () => {
    // forget the previous result, unless a request is still running
    if (!loading) {
      dispatch({
        type: SET_TAG_FILES_STATUS,
        payload: { loading: false, status: "idle", message: "" },
      });
    }
    setOpen(true);
  };

  // while ticking files in the table, this button finishes the pick
  if (selectMode) {
    return (
      <button
        type="button"
        className="tag-files-btn"
        onClick={() => {
          setSelectMode(false);
          setOpen(true);
        }}
      >
        Done ({selected.fileIds.length} selected)
      </button>
    );
  }

  return (
    <>
      <button
        type="button"
        className="tag-files-btn"
        onClick={handleOpen}
        disabled={loading}
      >
        {loading ? (
          <CircularProgress size={14} style={{ color: "#fff" }} />
        ) : (
          <LocalOfferIcon style={{ fontSize: 16 }} />
        )}
        {loading ? "Tagging..." : "Tag Files"}
      </button>

      {open && (
        <TagFilesDialog
          selected={selected}
          onChange={setSelected}
          onClose={() => setOpen(false)}
          onSuccess={() => {
            setSelected(EMPTY_SELECTION);
            setOpen(false);
          }}
          onPickFiles={() => {
            setOpen(false);
            setSelectMode(true);
          }}
        />
      )}
    </>
  );
}